import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Trophy } from "lucide-react";

export default function Squad() {
  const [data, setData] = useState({ rows: [], impact: { total_donated: 0, donations_count: 0 } });

  useEffect(() => {
    api.get("/squad/leaderboard").then((r) => setData(r.data));
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-6 md:px-10 py-10 md:py-14 space-y-10" data-testid="squad-page">
      <div>
        <div className="eyebrow">SQUAD</div>
        <h1 className="font-display text-5xl md:text-7xl uppercase mt-2 leading-none">The grind, ranked.</h1>
      </div>

      <div className="panel p-8 rounded-2xl text-center bg-obsidian text-white" data-testid="squad-impact">
        <div className="eyebrow text-lime mb-3">ALL-TIME CHARITY IMPACT</div>
        <div className="font-display text-6xl md:text-8xl text-lime leading-none">${Math.round(data.impact.total_donated).toLocaleString()}</div>
        <div className="font-mono text-xs uppercase tracking-[0.25em] text-neutral-400 mt-4">
          {data.impact.donations_count} DONATIONS · ACROSS FAILED STAKES
        </div>
      </div>

      <div className="panel rounded-2xl divide-y divide-neutral-200" data-testid="squad-leaderboard">
        <div className="px-6 py-4 flex items-center justify-between font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-500">
          <span>RANK · NAME</span>
          <span>DAYS · STAKED</span>
        </div>
        {data.rows.map((r, i) => (
          <div key={r.user_id} className={`px-6 py-4 flex items-center justify-between ${r.is_me ? "bg-lime/30" : ""}`} data-testid={`squad-row-${i}`}>
            <div className="flex items-center gap-4">
              <div className="font-display text-2xl text-neutral-400 w-8">{String(i + 1).padStart(2, "0")}</div>
              <div className="w-9 h-9 rounded-full bg-obsidian text-white flex items-center justify-center font-mono text-xs">{r.avatar_initials}</div>
              <div>
                <div className="font-display text-xl leading-none">{r.name}{r.is_me && <span className="font-mono text-[10px] tracking-[0.25em] ml-2 text-neutral-500">YOU</span>}</div>
                <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-500 mt-0.5">{r.active_challenges} active challenge{r.active_challenges === 1 ? "" : "s"}</div>
              </div>
            </div>
            <div className="text-right">
              <div className="font-display text-2xl leading-none">{r.days_completed}</div>
              <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-500 mt-0.5">${r.staked.toFixed(0)} staked</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
